import React from 'react';
import {CFGuide} from "./component/CFGuide";

function App() {
    return (
        <CFGuide/>
    );
}

export default App;
